import { request } from '@/utils/axiosFun.js'

//数据统计列表分页查询
export const getList = (params) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/dataStat/getDataStatPageList?pagenum=${params.pagenum}&pagesize=${params.pagesize}`,params)
}

//基层单位
export const getJiCeng = (params) => {
    // console.log(params)
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getCompanyOptionByRegion`,params)
}

//省
export const getProvice = () => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/region/getTopRegionList`)
}

//市
export const getCity = (params) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/region/getRegionListByCode?regionCode=${params.regionCode}`)
}

//变电站
export const getBianDianZhan = (params) => {
    return request('post', `/yunDuanUrl//dmsm-service-cloud/user/getSubstationOptionByCompany`,params)
}

//通过终端ID查询图谱数据
export const getHisDataMap = (params) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/dataStat/getHisDataMap?termId=${params.termId}`)
}

//下载台账
export const exportDataStat = (params) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/dataStat/exportDataStat`,params,'application/json;charset=UTF-8','')
}

//下载图谱
export const downloadMap = (params) => {
    return request('post', `/yunDuanUrl//dmsm-service-cloud/dataStat/downloadMap`,params, 'arraybuffer')
}

//下载数据
export const downloadData = (params) => {
    return request('post', `/yunDuanUrl//dmsm-service-cloud/dataStat/downloadData`,params, 'arraybuffer')
}